export function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

export async function getCroppedImg(imageSrc, pixels) {
  if (!pixels) throw new Error('Missing croppedAreaPixels');

  // pixels: { x, y, width, height } v PX!
  const img = await loadImage(imageSrc);

  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.floor(pixels.width));
  canvas.height = Math.max(1, Math.floor(pixels.height));
  const ctx = canvas.getContext('2d');

  // Ořízneme z originálního obrázku oblast v pixelech
  ctx.drawImage(
    img,
    Math.floor(pixels.x),
    Math.floor(pixels.y),
    Math.floor(pixels.width),
    Math.floor(pixels.height),
    0,
    0,
    Math.floor(pixels.width),
    Math.floor(pixels.height)
  );

  return canvas;
}
